import { Skeleton } from '@mui/material';

export const skeletonQR = () => {
  return <Skeleton sx={{ bgcolor: 'grey.900' }} variant='rectangular' width={293} height={293} />;
};
